import { render, staticRenderFns } from "./usermg.vue?vue&type=template&id=48b9fdbe&"
import script from "./usermg.vue?vue&type=script&lang=js&"
export * from "./usermg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports